<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import type { ComponentType } from 'svelte';
	import Icon from './Icon.svelte';
	import { trackAction } from '$lib/tracking';

	let className = '';
	export { className as class };
	export let tag: 'button' | 'a' = 'button';
	export let dark = false;

	export let leftIcon: ComponentType | undefined = undefined;
	export let rightIcon: ComponentType | undefined = undefined;
	export let shouldReload = true;
	export let trackingLabel = '';

	const dispatch = createEventDispatcher();

	function handleClick(event: MouseEvent) {
		if (trackingLabel) {
			trackAction('content', 'text', trackingLabel);
		}

		dispatch('click', event);
	}
</script>

<svelte:element
	this={tag}
	role={tag === 'button' ? 'button' : 'link'}
	on:click={handleClick}
	class={`inline-flex items-center text-copy text-textlink text-left underline underline-offset-4 hover:underline hover:decoration-2 focus:underline focus:decoration-2 ${className}`}
	class:font-bold={leftIcon || rightIcon}
	class:!text-textlink-darkmode={dark}
	data-sveltekit-reload
	{...shouldReload ? { 'data-sveltekit-reload': 'true' } : {}}
	{...$$restProps}
>
	{#if leftIcon}
		<Icon class="shrink-0 h-6!" component={leftIcon} />
	{/if}
	<slot />
	{#if rightIcon}
		<Icon class="shrink-0  h-6!" component={rightIcon} />
	{/if}
</svelte:element>
